<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </a>

    <div class="action-icon">
      <a
        class="btn btn-list-function"
        :href="`#/dashboard/call-flow/edit/${currentCallFlow.id}`"
        @click="editCallFlow(currentCallFlow.id, $event)"
      >
        <i
          v-tooltip.bottom.hover="$t('EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'EDIT'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <div class="action-icon m-t-2">
      <button
        class="btn btn-list-function"
        :disabled="duplicateId === currentCallFlow.id"
        @click="duplicateCallFlow(currentCallFlow.id, $event)"
      >
        <i
          v-tooltip.bottom.hover="$t('DUPLICATE')"
          class="fa fa-files-o"
          aria-hidden="true"
        />
        <span
          v-t="'DUPLICATE'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <div class="action-icon">
      <button
        class="btn btn-list-function"
        @click="deleteCallFlow(currentCallFlow, $event)"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <ChangeLogObjectButtonAction
      :object-id="currentCallFlow.id"
      :object-name="currentCallFlow.incomingQueryStringName"
      object-type="IVR"
    />
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'CallFlowActions',
  components: {
    ChangeLogObjectButtonAction
  },
  props:{
    currentCallFlow: {
      type: Object,
      default() {
        return {};
      }
    },
    duplicateId: {
      type: String,
      default: ''
    }
  },
  methods:{
    deleteCallFlow(id, e) {
      this.$emit('deleteCallFlow', id, e);
    },
    collapseActions() {
      this.$emit('collapse-actions', this.currentCallFlow.id);
    },
    editCallFlow(id, e) {
      this.$emit('editCallFlow', id, e);
    },
    duplicateCallFlow(id, e) {
      this.$emit('duplicateCallFlow', id, e);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>